export default __webpack_public_path__ + "static/media/3255.1751ec72.png";